<template>
  <div
    style="
      width:390px;
      height:780px;
      border-radius:var(--r-xl);
      background:var(--bg-canvas);
      overflow:hidden;
      display:flex;
      flex-direction:column;
      border:2px solid var(--stroke-2);
      box-shadow:0 0 0 8px var(--bg-muted), var(--shadow-28);
      margin:var(--s-16) auto;
    "
  >
    <!-- Notch bar -->
    <div
      style="
        height:28px;
        background:var(--bg-surface);
        display:flex;
        align-items:center;
        justify-content:center;
        flex-shrink:0;
        border-bottom:1px solid var(--stroke-1);
      "
    >
      <div
        style="
          width:80px;
          height:5px;
          border-radius:999px;
          background:var(--fg-disabled);
          opacity:0.4;
        "
      ></div>
    </div>

    <!-- Status bar -->
    <div
      style="
        padding:var(--s-8) var(--s-16);
        background:var(--bg-surface);
        border-bottom:1px solid var(--stroke-1);
        display:flex;
        align-items:center;
        justify-content:space-between;
        flex-shrink:0;
      "
    >
      <span style="font-size:var(--t-12);color:var(--fg-tertiary)">2 items need your input · Apr 16–30</span>
      <span style="font-size:var(--t-12);font-weight:var(--w-semibold);color:var(--fg-secondary)">1 / 2</span>
    </div>

    <!-- Queue area -->
    <div
      style="
        flex:1;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        padding:var(--s-20);
        position:relative;
      "
    >
      <div style="position:relative;width:100%;padding-bottom:28px">
        <!-- Back card peeking -->
        <div
          style="
            position:absolute;
            bottom:0;
            left:12px;
            right:12px;
            border-radius:var(--r-lg);
            background:var(--bg-subtle);
            border:1px solid var(--stroke-1);
            box-shadow:var(--shadow-4);
            height:72px;
            overflow:hidden;
            display:flex;
            align-items:flex-start;
            padding:var(--s-12);
            z-index:0;
            opacity:0.6;
          "
        >
          <span style="font-size:var(--t-13);color:var(--fg-tertiary);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Cleaning up old tickets</span>
        </div>

        <!-- Front card — uses tc-event-card pattern at larger padding -->
        <li
          class="tc-event-card"
          style="
            position:relative;
            z-index:1;
            padding:var(--s-20);
            list-style:none;
            cursor:default;
            box-shadow:var(--shadow-16);
          "
        >
          <div class="conf-bar"></div>
          <div class="tc-event-card-meta">
            <span class="tc-event-source-badge tc-event-source-outlook" title="Outlook">O</span>
            <span class="tc-event-card-time">Tue 17 · 10:00 · 1h</span>
          </div>
          <div class="tc-event-card-title" style="font-size:var(--t-20);line-height:var(--lh-20);margin-top:var(--s-4)">
            External call w/ Globex
          </div>
          <div class="mt-2">
            <span
              style="
                display:inline-flex;
                align-items:center;
                gap:var(--s-4);
                background:var(--brand-tint-10);
                color:var(--brand-primary);
                font-size:var(--t-13);
                font-weight:var(--w-semibold);
                padding:var(--s-4) var(--s-10);
                border-radius:var(--r-md);
              "
            >
              <svg viewBox="0 0 14 14" fill="none" aria-hidden="true" style="width:12px;height:12px">
                <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.3"/>
                <path d="M7 4v3.5l2 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
              </svg>
              1h
            </span>
          </div>
        </li>
      </div>
    </div>

    <!-- Action bar -->
    <div
      style="
        padding:var(--s-12) var(--s-16) var(--s-20);
        background:var(--bg-surface);
        border-top:1px solid var(--stroke-1);
        display:flex;
        flex-direction:column;
        gap:var(--s-8);
        flex-shrink:0;
      "
    >
      <button type="button" class="btn btn-primary tc-btn-touch w-100">
        Pick project
      </button>
      <button type="button" class="btn btn-outline-secondary w-100">
        Dismiss
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
